import {orderStatusActionTypes} from "./order-status-action-types";
const initialOrderStatusState = {
    orders: []
};

export const orderStatus = (state = initialOrderStatusState, action) => {
    switch (action.type) {
        case orderStatusActionTypes.ORDER_STATUS_RECEIVED:
            return {orders: action.data};
        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/orderStatus/reducers/order-status-reducer.js